import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ProfileAvatar.module.css';
import api, { API_BASE_URL } from '../../services/api';

const ProfileAvatar = () => {
  const navigate = useNavigate();
  const [avatarUrl, setAvatarUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [uploadMsg, setUploadMsg] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const resp = await api.get('/auth/me');
        const avatar = resp?.data?.avatar;
        if (avatar) {
          setAvatarUrl(avatar.startsWith('http') ? avatar : `${API_BASE_URL}${avatar}`);
        }
      } catch {
        // ignore
      }
    };
    fetchProfile();
  }, []);

  const handleAvatarChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    setUploading(true);
    setUploadMsg('');
    try {
      const resp = await api.post('/upload/avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const url = resp?.data?.url;
      if (url) {
        setAvatarUrl(url.startsWith('http') ? url : `${API_BASE_URL}${url}`);
        // 保存到用户资料
        try {
          await api.post('/auth/avatar', { avatar: url });
        } catch (saveErr) {
          console.error('保存头像到资料失败', saveErr);
        }
        setUploadMsg('头像已更新');
      } else {
        setUploadMsg('上传成功，但未获取到URL');
      }
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || '上传失败，请重试';
      setUploadMsg(msg);
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div className={styles.avatarPage}>
      <header className={styles.topBar}>
        <button
          type="button"
          className={styles.backButton}
          onClick={() => navigate('/profile/account')}
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <div className={styles.pageTitle}>上传头像</div>
      </header>

      <div className={styles.avatarCard}>
        <div className={styles.avatarInfo}>
          <div className={styles.avatarPreview}>
            {avatarUrl ? (
              <img src={avatarUrl} alt="avatar" />
            ) : (
              <div className={styles.avatarPlaceholder}>无头像</div>
            )}
          </div>
          <div className={styles.avatarText}>
            <div className={styles.avatarTitle}>头像</div>
            <div className={styles.avatarDesc}>建议上传 400x400 内的清晰图片</div>
            {uploadMsg && <div className={styles.avatarMsg}>{uploadMsg}</div>}
          </div>
        </div>
        <label className={styles.uploadBtn}>
          <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>upload</span>
          {uploading ? '上传中...' : '选择图片上传'}
          <input
            type="file"
            accept="image/*"
            onChange={handleAvatarChange}
            disabled={uploading}
          />
        </label>
      </div>
    </div>
  );
};

export default ProfileAvatar;

